import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getCatalogGradeChemistryLimit = async (gradeId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "GradeId", value: gradeId });
	return await apiService.callV2(
		"[LAB].[GetCatGradeChemistryLimits]",
		parameters,
	);
};
